import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

function GlobalErrorPage() {
  const navigate = useNavigate();

  return (
    <Result
      status="500"
      title="Error"
      subTitle="Sorry, something went wrong."
      extra={
        <Button type="primary" onClick={() => navigate(0)}>
          Refresh Page
        </Button>
      }
    />
  );
}

export default GlobalErrorPage;
